<a class="tableSortableHeader" (click)="headerClick()">{{ title }}</a>
<span
  *ngIf="sortBy == columnName"
  class="icon fa"
  [ngClass]="{ 'fa-caret-down': reverse, 'fa-caret-up': !reverse }"
></span>
